// extracted by mini-css-extract-plugin
export default {"button":"button_button__4-vvU","transparent":"button_transparent__EAQ+3","submit":"button_submit__UMmr5","small":"button_small__9ggcU","footer":"button_footer__9BEzR"};